import {
    Typography,
    TextField,
    Box,
    Tabs,
    Tab,
    Button,
    Select,
    MenuItem,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import { TreeView, TreeItem } from "@mui/lab";

import TemplateEditorAce from "../../../components/code/ace/template.editor";
import { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";

const EmbedAgent: React.FC<{
    item: any;
}> = ({ item }) => {
    const [embedCode, setEmbedCode] = useState("");
    const dataProvider = useDataProvider();

    // Fetch options for the file selector using the dataProvider
    useEffect(() => {
        const fetchEmbedCode = async () => {
            const embedCode = getMockEmbedCode();
            setEmbedCode(embedCode);
        };

        fetchEmbedCode();
    }, [dataProvider, item]); // Add item as dependency so it updates when the record changes


    const getMockEmbedCode = () => {
        // Extract assistantKey from the record, fallback to a default if not available
        const assistantKey = item?.assistantKey || 'default.assistant';
        
        // Build the iframe URL with the assistantKey parameter
        const iframeUrl = `http://localhost:6001/?assistantKey=${encodeURIComponent(assistantKey)}&theme=liquid&layout=drawer&height=600`;
        
        return `
      <html>
        <body>
            <!-- Embed code for assistant: ${assistantKey} -->
            <iframe 
                src="${iframeUrl}" 
                width="400" 
                height="600" 
                frameborder="0"
                title="${item?.name || 'AI Assistant'} Chat"
            ></iframe>
        </body>
      </html>
      `;
    };


    return (
        <Box sx={{ 
            padding: "16px",
            width: '100%',
            maxWidth: 'none', // Override react-admin's default max-width
            '& .ra-input': { // Override react-admin input styles
                width: '100%',
                maxWidth: 'none'
            }
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">
                    Embed Code
                </Typography>
                <Button variant="contained" color="primary" onClick={() => {
                    // Open a new tab with the embed code using the assistantKey
                    const assistantKey = item?.assistantKey || 'default.assistant';
                    const previewUrl = `http://localhost:6001/?assistantKey=${encodeURIComponent(assistantKey)}&theme=liquid&layout=drawer`;
                    window.open(previewUrl, "_blank");
                }}>
                    Preview
                </Button>
            </Box>
            <Typography variant="body1" gutterBottom>
                Use This Code To Embed This Agent ({item?.assistantKey || 'Unknown'}) In Your Application or Website
            </Typography>
            <Box sx={{ width: '100%', minHeight: '400px' }}>
                <TemplateEditorAce
                    value={embedCode}
                    onChange={() => { }}
                    mode="html"
                />
            </Box>
        </Box>
    );
};

export default EmbedAgent;
